import { render } from "./PromoPlan.vue?vue&type=template&id=0c19afb3"
import script from "./PromoPlan.vue?vue&type=script&lang=js"
export * from "./PromoPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__